// src/api.js

let _events = [
    {
        id: 1,
        event_type_id: 1,
        title: "Starter Saturdays",
        sub_title: "Career acceleration intro",
        description: "Every alternate Saturday • 11:00 AM",
        about: "",
        date: Date.parse("2025-06-15T11:00:00Z"),
        detailed_description: "",
        detailed_description_web: {},
        member_heading: "",
        detail: {},
        join_url: "https://meet.example.com/starter",
        is_active: 1,
        location: "Online",
        fees: 0,
        duration: 3600000,
        thumbnail: "https://via.placeholder.com/150",
        web_poster: "https://via.placeholder.com/600x200",
        app_poster: "https://via.placeholder.com/600x200",
        google_form: "",
        color_code: "#1D8CF8",
        platform_type: "Zoom",
        is_banner: true,
        display_order: 0
    },
    {
        id: 2,
        event_type_id: 6,
        title: "Industry Insights",
        sub_title: "Deep dive webinar",
        description: "",
        about: "",
        date: Date.parse("2025-06-20T16:00:00Z"),
        detailed_description: "",
        detailed_description_web: {},
        member_heading: "",
        detail: {},
        join_url: "https://company.example.com/webinar",
        is_active: 1,
        location: "Online",
        fees: 0,
        duration: 3600000,
        thumbnail: "https://via.placeholder.com/150",
        web_poster: "https://via.placeholder.com/600x200",
        app_poster: "https://via.placeholder.com/600x200",
        google_form: "",
        color_code: "#28A745",
        platform_type: "Webex",
        is_banner: false,
        display_order: 1
    },
    {
        id: 3,
        event_type_id: 2,
        title: "Monthly AMA",
        sub_title: "First Monday Q&A",
        description: "",
        about: "",
        date: Date.parse("2025-07-07T14:00:00Z"),
        detailed_description: "",
        detailed_description_web: {},
        member_heading: "",
        detail: {},
        join_url: "https://company.example.com/ama",
        is_active: 1,
        location: "Online",
        fees: 0,
        duration: 3600000,
        thumbnail: "https://via.placeholder.com/150",
        web_poster: "https://via.placeholder.com/600x200",
        app_poster: "https://via.placeholder.com/600x200",
        google_form: "",
        color_code: "#FF8C00",
        platform_type: "Teams",
        is_banner: false,
        display_order: 2
    }
];



const delay = ms => new Promise(res => setTimeout(res, ms));
const API = `${process.env.REACT_APP_API_URL}/user/event`
// const API = `http://192.168.1.3:5443/api/user/event`

export const api = {
    fetchEventTypes: async () => {
        const data = await fetch(`${API}/event-types`);
        return data.json();
    },
    fetchEvents: async (page = 1, limit = 10, category = 'upcoming') => {
        const params = new URLSearchParams({ page, limit });
        if (category && category !== 'all') params.append('category', category);
        else if (category === 'all') params.append('category', 'all');

        const res = await fetch(`${API}/getAllEvents?${params.toString()}`);
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
    },
    createEvent: async evt => {
        const res = await fetch(`${API}/createnewEvent`, {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(evt)
        });


        return res.json();
    },
    updateEvent: async (id, updates) => {
        try {
            const res = await fetch(`${API}/updateEvents/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updates)
            });
            console.log("res", res)

            return res.json();
        } catch (error) {
            console.log(error)
            return null
        }
    },
    deleteEvent: async id => {
        await delay(200);
        const idx = _events.findIndex(e => e.id === id);
        if (idx === -1) throw new Error("Event not found");
        _events.splice(idx, 1);
        return true;
    }
};
